import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 16px;
`

export const Field = styled.div`
  font-size: 16px;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 16px;
  line-height: 24px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`

export const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${myPalette.coral.main};
  margin-bottom: 16px;
  text-align: center;
`
